import { createFileRoute } from '@tanstack/react-router';

import { PlansListPage } from '@/pages/plans/plans-list-page';

export const Route = createFileRoute('/plans/')({
  component: PlansListPage,
});
